
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 18C9.477 18 5 22.477 5 28v44c0 5.523 4.477 10 10 10h49c5.523 0 10-4.477 10-10V28c0-5.523-4.477-10-10-10H15zm49.5 15a5.5 5.5 0 100-11 5.5 5.5 0 000 11z","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M88.945 31.624L74 40.572V59.43l14.945 8.947C91.612 69.972 95 68.05 95 64.942V35.058c0-3.108-3.388-5.029-6.055-3.433z"}})])
          )
        }
      }
    